import axios from 'axios'
import { Toast } from 'vant'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 10000,
});

// Add a request interceptor
http.interceptors.request.use(config => {
	//请求时调用轻提示
	Toast.loading({
		message: "加载中...",
		forbidClick: true,
		loadingType: 'spinner',
		duration: 0
	});
	return config;
}, error => {
	return Promise.reject(error);
});

// Add a response interceptor
http.interceptors.response.use(response => {
	//响应时消除轻提示
	Toast.clear();
	return response.data;
}, error => {
	return Promise.reject(error);
});

export default http